var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-node-list"},[_c('ul',{staticClass:"flex-center"},_vm._l((_vm.nodes),function(item,i){return _c('li',{key:i,class:{'z-now': item.current}},[_vm._m(0,true),_c('p',[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot flex-center"},[_c('i',{staticClass:"tf tf-check"})])
}]

export { render, staticRenderFns }